<template>
    <div class="user_core">
        <Header :title="title"></Header>
        <van-row class="info_body">
            <van-col span="24" class="info_s">
                <van-tabs v-model="active" type="card" @click="onClick">
                    <van-tab :title="$t('message.tabtitle1')">
                        <Maslist :tabindex="tabindex"></Maslist>
                    </van-tab>
                    <van-tab :title="$t('message.tabtitle2')">
                        <Maslist :tabindex="tabindex"></Maslist>
                    </van-tab>
                    <van-tab :title="$t('message.tabtitle3')">
                        <Maslist :tabindex="tabindex"></Maslist>
                    </van-tab>
                </van-tabs>


            </van-col>
        </van-row>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import Maslist from '@/components/user/Maslist'


    export default {
        name: "Message",
        data(){
            return{
                title:this.$t('message.pagetitle'),
                active:0,
                tabindex:0
            }
        },
        components:{
            Header,
            Footer,
            Maslist
        },
        methods: {

            onClick(name, title) {
                //this.$toast(title);
                this.tabindex = name;
            },
        },
    }
</script>

<style scoped lang="scss">
    .user_core{
        min-height: 650px;
        background: url("~@/assets/images/bg_header.png") no-repeat center 45px;
        background-size: 100% ;
        .info_body{
            width: 92%;
            min-height: 500px ;
            margin: 18px auto 0 auto;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
            .info_s {
                margin: 15px auto 40px auto;


            }
        }
    }
</style>
